import React from "react";
import { CalendarDays, MapPin, Clock } from "lucide-react";
import { Reveal, WfButton, ImageWithCredit } from "@/components/site/primitives";
import { EVENT } from "@/content/worldFarmers";

export const EventsV4 = () => (
  <section id="events" aria-labelledby="events-v4-heading" className="bg-[var(--wf-cream)] py-16 sm:py-20 lg:py-28">
    <div className="wf-container">
      <Reveal>
        <div className="relative overflow-hidden rounded-sm border border-[var(--wf-border)] bg-white shadow-[var(--wf-shadow)]">
          <div className="grid grid-cols-1 lg:grid-cols-2">
            <div className="relative min-h-[300px]">
              <ImageWithCredit src={EVENT.image} alt={EVENT.alt} className="h-full" imgClassName="h-full" />
              <div className="absolute left-5 top-5 flex flex-col items-center rounded-sm bg-white/95 px-5 py-3 text-center shadow-[var(--wf-shadow)] backdrop-blur-sm">
                <span className="text-xs font-semibold uppercase tracking-[0.16em] text-[var(--wf-maroon)]">{EVENT.dateParts.month}</span>
                <span className="font-serif text-4xl font-semibold leading-none text-[var(--wf-ink)]">{EVENT.dateParts.day}</span>
                <span className="text-xs tracking-wide text-muted-foreground">{EVENT.dateParts.year}</span>
              </div>
            </div>
            <div className="flex flex-col justify-center gap-4 p-8 sm:p-12">
              <span className="w-fit rounded-full bg-[var(--wf-clay)]/15 px-3 py-1 text-xs font-semibold uppercase tracking-[0.14em] text-[var(--wf-clay)]">{EVENT.badge}</span>
              <h2 id="events-v4-heading" className="font-serif text-3xl font-semibold text-[var(--wf-ink)] sm:text-4xl">{EVENT.title}</h2>
              <ul className="flex flex-col gap-2 text-sm text-muted-foreground">
                <li className="flex items-center gap-2"><CalendarDays className="h-4 w-4 text-[var(--wf-green-text)]" aria-hidden="true" />{EVENT.date}</li>
                <li className="flex items-center gap-2"><MapPin className="h-4 w-4 text-[var(--wf-green-text)]" aria-hidden="true" />{EVENT.location}</li>
                <li className="flex items-center gap-2"><Clock className="h-4 w-4 text-[var(--wf-green-text)]" aria-hidden="true" />{EVENT.ticketingNote}</li>
              </ul>
              <p className="text-sm leading-6 text-muted-foreground">{EVENT.body}</p>
              <div className="mt-1">
                <WfButton as="a" href={EVENT.href} withArrow className="px-6" data-testid="events-featured-event-cta-button">{EVENT.cta}</WfButton>
              </div>
            </div>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
